import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class MyBremboPartsPage extends BasePage {
    public static async init() {
        await super.init();

        this.setHeader();
        this.setCatalogueSearch();
        this.setMyAnalytics();
    }

    private static setHeader() {
        if ((<any>window).App.bag.area) {
            document.querySelector(".list-item >.item >.button[data-area=\"" + (<any>window).App.bag.area + "\"]")?.classList.add("active");
        }

        if ((<any>window).App.bag.page) {
            let box = <any>document.querySelector(".aside-menu");
            var page = document.querySelector(".aside-menu >.link[data-page=\"" + (<any>window).App.bag.page + "\"]");
            page.classList.add("active");

            box.scrollLeft = (<any>page).offsetLeft - box.offsetLeft - 50;
        }

        if ((<any>window).App.bag.area === "Training") {
            document.querySelector("#ExecuteTest")?.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("myTrainingStore/setTrainingTestVisible", true);
            });

            document.querySelector("#TrainingFeedback")?.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("myTrainingStore/setTrainingFeedbackVisible", true);
            });
        }
    }

    private static setCatalogueSearch() {
        (<any>window).App.instances.vm.$store.commit("catalogueSearchStore/setCatalogueSearchHidden", true);

        document.querySelectorAll(".show-search-button").forEach(element => {
            element.addEventListener("click", event => {
                (<any>window).App.instances.vm.$store.commit("catalogueSearchStore/setCatalogueSearchHidden", false);
            });
        });
    }

    private static setMyAnalytics() {
        document.querySelector("#ExecuteTest")?.addEventListener("click", x => {
            GTagHelper.sendEvent("click", "course_test", "start");
        });

        document.querySelector("#GenericDownload")?.addEventListener("click", x => {
            GTagHelper.sendEvent("file_download", "course_certificate", "generic");
        });

        document.querySelector("#BremboExpertDownload")?.addEventListener("click", x => {
            GTagHelper.sendEvent("file_download", "course_certificate", "expert");
        });
    }
}